import { NgIf } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NbCardModule, NbIconModule } from '@nebular/theme';
import { Store } from '@ngxs/store';
import { AmplifyAuthService } from 'src/app/core/services/amplify-auth.service';
import { SpinnerComponent } from 'src/app/shared/ui/spinner/spinner.component';
import { ENVIRONMENT } from 'src/environments/environment';
import { SetIsLogedIn, SetUserGroups, SetUsername } from '../redux';

@Component({
  selector: 'app-okta-redirect',
  templateUrl: './okta-redirect.component.html',
  styleUrls: ['./okta-redirect.component.css'],
  imports: [SpinnerComponent, NbCardModule, NgIf, NbIconModule]
})
export class OktaRedirectComponent implements OnInit {
  public accessDenied = false;
  public environment = ENVIRONMENT.name;

  constructor(
    private store: Store,
    private router: Router,
    private route: ActivatedRoute,
    private amplifyAuthService: AmplifyAuthService
  ) {}

  public ngOnInit(): void {
    if (this.route.snapshot.queryParams.error === 'access_denied') {
      this.accessDenied = true;
      return;
    }

    this.initializeUser();
  }

  private async initializeUser(): Promise<void> {
    await new Promise((resolve) => setTimeout(resolve, 1000));

    const session = await this.amplifyAuthService.fetchAuthSession({ forceRefresh: true });

    if (!session.tokens?.idToken) {
      console.error('No idToken after callback. OAuth code was not exchanged.');
      return;
    }
    const payload = session.tokens.idToken.payload;
    const rawGroups = payload?.['custom:groups'];

    const groups = this.parseGroups(rawGroups);
    const email = typeof payload?.email === 'string' ? payload.email : '';

    this.store.dispatch([new SetUsername(email), new SetUserGroups(groups), new SetIsLogedIn(true)]);

    const returnUrl = sessionStorage.getItem('returnUrl');
    sessionStorage.removeItem('returnUrl');

    this.router.navigateByUrl(returnUrl || '/quick-start');
  }

  private parseGroups(value: unknown): string[] {
    if (typeof value !== 'string') {
      return [];
    }

    try {
      const parsed = JSON.parse(value);
      return Array.isArray(parsed) ? parsed : [];
    } catch {
      return [];
    }
  }
}
